import packageJson from '../../../package.json';

function Version() {

  return (
    <div className="game-version">
      <span>{packageJson.version || ''}</span>
    </div>
  );
}

export default Version;

